const RECAPTCHA_SITE_KEY = '6LfksYAtAAAAAN-ZCqFnBo1gqwje6BS_kLFYMmnt';

let loadPromise = null;

const loadRecaptcha = () => {
    if (loadPromise) {
        return loadPromise;
    }

    loadPromise = new Promise((resolve, reject) => {
        if (window.grecaptcha) {
            resolve(window.grecaptcha);
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=' + RECAPTCHA_SITE_KEY;
        script.async = true;
        script.onload = () => resolve(window.grecaptcha);
        script.onerror = () => {
            loadPromise = null;
            reject(new Error('reCAPTCHA script failed to load'));
        };
        document.head.appendChild(script);
    });

    return loadPromise;
};

// Vrací token, nebo null když se reCAPTCHA nepodaří načíst (adblock apod.) —
// formulář se odešle i tak a rozhodne backend.
const getRecaptchaToken = (action) => loadRecaptcha()
    .then((grecaptcha) => new Promise((resolve) => {
        grecaptcha.ready(() => {
            grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: action }).then(resolve, () => resolve(null));
        });
    }))
    .catch(() => null);

export { loadRecaptcha, getRecaptchaToken };
